module.exports = __webpack_public_path__ + "static/media/promo-zg.fde8f48d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-zg.jpg
// module id = 325
// module chunks = 0